import { useState, useEffect } from "react";
//API
import { axiosWithAuth } from "../../../../api/axiosConfig";
import {
  urlCreateMaquinas,
  urlEditMaquinas,
  urlGetMaquinasTipos,
} from "../../../../api/URLs/mantenimiento";
//HOOKS
import { useAlertModal } from "../../../../hooks/useAlertModal";
//FORMIK & YUP
import { Formik, Form } from "formik";
//--Basic
import CustomAlertMsj from "../../../../components/Tools/Basics/CustomAlertMsj";
import ButtonSubmit from "../../../../components/Tools/Basics/BtnSubmit";
import FormTitle from "../../../../components/Tools/Basics/FormTitle";
import CustomInput from "../../../../components/Tools/Inputs/CustomInput";
import CenterSpinner from "../../../../components/Tools/Basics/Spinner";
import CustomDropdown from "../../../../components/Tools/Inputs/CustomDropdown";

const FormMaquinas = ({ maquina, reFetch, setReFetch }) => {
  //useAlertModal
  const {
    alertMsj,
    alertState,
    alertType,
    handleAlertSuccess,
    handleAlertError,
  } = useAlertModal();
  //States
  const [sendLoading, setSendLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [selectedTipo, setSelectedTipo] = useState(null);
  //Initial Values
  let newValues, updateValues;
  if (maquina) {
    updateValues = {
      id: maquina.id_maquina,
      id_interno: maquina.id_interno ? maquina.id_interno : "",
      marca: maquina.marca ? maquina.marca : "",
      modelo: maquina.modelo ? maquina.modelo : "",
    };
  } else {
    newValues = {
      id_interno: "",
      marca: "",
      modelo: "",
    };
  }
  const initialValues = maquina ? updateValues : newValues;
  //GET tipos
  const getTipos = async () => {
    try {
      setLoading(true);
      const api_response = await axiosWithAuth.get(urlGetMaquinasTipos);
      setTipos(api_response.data);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleAlertError(auxError);
    } finally {
      setLoading(false);
    }
  };
  //POST - PUT de choferes
  const handleSubmit = async (values) => {
    const merged = {
      ...values,
      id_tipo: selectedTipo ? selectedTipo.id : maquina.id_tipo,
    };
    try {
      setSendLoading(true);
      let api_response;
      if (!maquina) {
        api_response = await axiosWithAuth.post(urlCreateMaquinas, merged);
      } else {
        api_response = await axiosWithAuth.put(urlEditMaquinas, {
          ...merged,
          id_cheklist: maquina.id_checklist ? maquina.id_checklist : null,
        });
      }
      setReFetch(!reFetch);
      handleAlertSuccess(api_response);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleAlertError(auxError);
    } finally {
      setSendLoading(false);
    }
  };
  useEffect(() => {
    getTipos();
  }, []);
  if (loading) return <CenterSpinner />;
  if (alertState === 1)
    return <CustomAlertMsj alertMsj={alertMsj} alertType={alertType} />;
  return (
    <div>
      <FormTitle prop={maquina} text={"Maquina"} />
      {alertState === 2 ? (
        <CustomAlertMsj alertMsj={alertMsj} alertType={alertType} />
      ) : null}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <CustomDropdown
              options={tipos}
              onSelect={(t) => setSelectedTipo(t)}
              defaultOption={maquina ? { tipo: maquina.tipo } : null}
              displayProperty={"tipo"}
              btnName={"Seleccione un tipo"}
              label={"Tipo de maquina"}
            />
            <CustomInput
              name={"id_interno"}
              label={"Id Interno"}
              placeholder={"Ingresar Id Interno"}
              loading={sendLoading}
            />
            <CustomInput
              name={"marca"}
              label={"Marca"}
              placeholder={"Ingresar Marca"}
              loading={sendLoading}
            />
            <CustomInput
              name={"modelo"}
              label={"Modelo"}
              placeholder={"Ingresar Modelo"}
              loading={sendLoading}
            />
            <ButtonSubmit
              prop={maquina}
              isSubmitting={isSubmitting}
              loading={sendLoading}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FormMaquinas;
